import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems
} from '@headlessui/react';
import { ChevronDownIcon, PlusIcon } from '@heroicons/react/20/solid';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import profile_img from "../../assets/avatar_placeholder.png";
import { useLocalStorage } from "../../hooks";
import { userState } from "../../redux/reducers/userReducer";


import axios from 'axios';
import { useTranslation } from 'react-i18next';
import * as userActions from "../../redux/reducers/userReducer";
import { getUrlForUsers } from '../../utils/confighelpers';
import BZLogo from '../BZLogo';
import Notifications from '../Notifications';
import TwButton from './TwButton';
import TwInitialsAvatar from './TwInitialsAvatar';
import I18nLanguageDropdown from '../I18nLanguageDropdown';

export default function TwAppBar(props) {
  const {
    headTitle = "",
    logout,
  } = props
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const [newDraftEventData, setNewDraftEventData] = useLocalStorage("newDraftEventData");
  const userReduxState = useSelector(userState);
  const navigate = useNavigate();

  const userFullname = () => {
    let splitName = (userReduxState.userData?.fullName || "")?.split(' ');
    let fullname = splitName.length ? splitName[0] : []
    if (splitName.length > 1) {
      fullname += " " + splitName[1].substring(0, 1) + "."
    }
    return fullname;
  };

  const userNavigation = [
    {
      // label: "Account Settings",
      label: "pageTitle.accountSettings",
      navigate: { to: "/my-account" },
    },
    {
      // label: t("authentication.logout"),
      label: "authentication.logout",
      navigate: "logout",
    }
  ]

  const updateUserProfile = async (businessType) => {
    const schoolUpdateBody = {
      businessType: businessType,
    };
    const userUpdateConfig = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      headers: {
        "x-access-token": userToken,
      },
      data: schoolUpdateBody,
    };
    const userUpdateRequest = await axios(userUpdateConfig);
    if (userUpdateRequest.status === 200) {
      if (userUpdateRequest.data.statusCode === 200) {
        dispatch(userActions.setBusinessType(businessType));
      }
    }
  };

  return (
    <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
      <div className="flex flex-row gap-2 flex-1 items-center grid-cols-1">
        {/* {headTitle ? (<h3 className={"font-extrabold text-2xl text-primary content-center"}>
          {headTitle}
        </h3>)} */}
        <div className="py-3">
          <BZLogo className="max-h-8 sm:!w-auto" />
        </div>
      </div>
      <div className="flex items-center gap-x-4 lg:gap-x-6">
        <TwButton
          variant={"default-box"}
          className="hidden lg:flex sm:min-w-32 truncate"
          onClick={() => {
            setNewDraftEventData({});
            navigate("/myevents/new");
          }}
        >
          <PlusIcon className='size-5' />&nbsp;&nbsp;{t("myEvents.createEvent")}
        </TwButton>
        <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" />
        <I18nLanguageDropdown />
        <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" />


        {/* Notification */}
        {/* <TwAppBarIconButton srTitle={"View notifications"} iconName={BellIcon} /> */}
        <Notifications srTitle={"View notifications"} />

        {/* Separator */}
        <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" />

        {/* Profile dropdown */}
        <Menu as="div" className="relative">
          <MenuButton className="-m-1.5 flex items-center p-1.5 rounded-full bg-zinc-300">
            <span className="sr-only">Open user menu</span>
            {userReduxState.userData?.profilePic ? (<img
              className={"1xs:size-6 size-8 md:size-8 lg:size-9 rounded-full bg-gray-50"}
              alt="" src={userReduxState.userData?.profilePic ?? profile_img} />) : (
              <TwInitialsAvatar name={userFullname()} />
            )}
            {/* <span className="inline-block size-8 overflow-hidden rounded-full bg-gray-100">
                <svg fill="currentColor" viewBox="0 0 24 24" className="size-full text-gray-300">
                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </span> */}
            <span className="hidden lg:flex lg:items-center">
              <span aria-hidden="true" className="ml-4 text-sm/6 font-semibold text-gray-900">
                {userFullname()}
              </span>
              <ChevronDownIcon aria-hidden="true" className="ml-2 size-5 text-gray-400" />
            </span>
          </MenuButton>
          <MenuItems
            transition
            className="absolute right-0 z-10 mt-2.5 [min-w-36] min-w-0 flex-auto origin-top-right rounded-md bg-white py-2 ring-1 shadow-lg ring-gray-900/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
          >
            {userNavigation.map((item) => (
              <MenuItem key={item.label}>
                <button
                  onClick={async () => {
                    // handleCloseUserMenu();
                    if (item.navigate === "logout") {
                      return await logout();
                    } else {
                      navigate(item.navigate.to, {
                        state: item.navigate.state,
                      });
                    }
                  }}
                  className="truncate w-full px-3 py-1 text-start text-sm/6 text-gray-900 hover:bg-gray-50 hover:outline-hidden focus:bg-gray-50 focus:outline-hidden"
                >
                  {/* {item.label} */}
                  {t(item.label)}
                </button>
              </MenuItem>
            ))}
          </MenuItems>
        </Menu>
      </div>
    </div >
  );
}
